export const isDefined = (value? : any) => value !== undefined && value !== null;
export const isValidBoolean = (value? : boolean) => value === true || value === false;
export const isValidNumber = (value? : any) => isDefined(value);
export const isValidText = (value? : string) => isDefined(value) && value !== "";
